module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [(!_vm.loading) ? _c('header', {
    staticClass: "c-toolbar"
  }, [_c('div', {
    staticClass: "l-level"
  }, [_c('div', {
    staticClass: "l-level__left"
  }, [(_vm.fromModuleDefinition !== null) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.fromModuleDefinition.logo,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "i-arrow icon-arrow-right"
  }), _vm._v(" "), (_vm.fromModuleDefinition !== null) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.toModuleDefinition.logo,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "c-toolbar__title title"
  }, [_vm._v("Editar produto")])])])]) : _vm._e(), _vm._v(" "), (_vm.product) ? _c('div', [_c(_vm.productEditComponent, {
    ref: "marketplaceEditProduct",
    tag: "component",
    attrs: {
      "product": _vm.product
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('save.label')))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e73a776","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductMarketplace/Edit.vue
// module id = 3331
// module chunks = 0